import CPContactDetailsView from 'text!../views/cp-contact-details.html';
import CPPolicyInfoView from 'text!../views/cp-policy-info.html';
import CPBuildingsAndLocationsView from 'text!../views/cp-buildings-locations.html';
import CPContactDetailsCtrl from '../controllers/CPContactDetailsCtrl';
import CPPolicyInfoCtrl from '../controllers/CPPolicyInfoCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        cpContactDetails: {
            parent: wizardParentState,
            template: CPContactDetailsView,
            controller: CPContactDetailsCtrl
        },
        cpBuildingsAndLocations: {
            parent: wizardParentState,
            template: CPBuildingsAndLocationsView
        },
        cpPolicyInfo: {
            parent: wizardParentState,
            controller: CPPolicyInfoCtrl,
            template: CPPolicyInfoView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/cp/config/RouteConfig.js
// module id = 2141
// module chunks = 0